module.exports = __webpack_public_path__ + "public/images/slider/speaker-7.c9a216480421d6e8f3b7f7246b9e530a.jpg";